import htmlToPdfmake from "html-to-pdfmake"
import {
    LangType,
    CcLibrarySetList,
} from "client/store"
import { MtProject } from "server/models"
import * as Const from "client/components/pdfmake/template/const"

const OverviewPage = (
    setList: CcLibrarySetList,
    setIds: readonly number[],
    project: MtProject,
    lang: LangType,
) => {
    const setNameList: string[] = []
    setIds.forEach((setId) => {
        const set = setList[setId]
        setNameList.push(set.name)
    })

    return [
        {
            pageBreak: "before",
            style: Const.HEADER,
            text: project.name,
        },
        {
            style: Const.SUB_HEADER,
            text: `1.   ${lang.projectDescription}`,
            ...Const.TOC_HEADER_BASE,
        },
        {
            style: Const.PARAGRAPH,
            stack: htmlToPdfmake(project.description),
        },
        {
            style: Const.SUB_HEADER,
            text: `2.   ${lang.complianceSets}`,
            ...Const.TOC_HEADER_BASE,
        },
        {
            style: Const.PARAGRAPH,
            text: lang.complianceSetsReport,
            italics: true,
            margin: [0, 5, 0, 10],
        },
        {
            style: Const.LIST,
            ul: setNameList,
        },
    ] as any[]
}
export default OverviewPage
